<template>
  <div
    v-if="visible"
    :class="'fullscreen cvpreview' + className"
    :style="{ width: boxWidth || '', zIndex: `${zindex}` }"
  >
    <div class="preview-title" @mousedown="domdrag($el, $event)">
      <h2>附件预览</h2>
      <div>
        <a v-if="!isMax" class="preview-max" href="javascript:;" title="最大化" @click="max"></a>
        <a v-else class="preview-revert" href="javascript:;" title="还原" @click="revert"></a>
        <a class="preview-close" href="javascript:;" title="关闭" @click="close"></a>
      </div>
    </div>
    <div class="preview-resizeL" @mousedown="resize($el, $event.target, true, false, false, true)"></div>
    <div class="preview-resizeT" @mousedown="resize($el, $event.target, false, true, true, false)"></div>
    <div class="preview-resizeR" @mousedown="resize($el, $event.target, false, false, false, true)"></div>
    <div class="preview-resizeB" @mousedown="resize($el, $event.target, false, false, true, false)"></div>
    <div class="preview-resizeLT" @mousedown="resize($el, $event.target, true, true, false, false)"></div>
    <div class="preview-resizeTR" @mousedown="resize($el, $event.target, false, true, false, false)"></div>
    <div class="preview-resizeBR" @mousedown="resize($el, $event.target, false, false, false, false)"></div>
    <div class="preview-resizeLB" @mousedown="resize($el, $event.target, true, false, false, false)"></div>
    <div v-if="dragLeft" class="preview-cover"></div>

    <div v-loading="loading" class="preview-content col-1" style="position:relative">
      <div v-if="file && userInservice" class="preview-download" @click="downloadFile">下载</div>
      <iframe
        v-show="suffix !== 'jpg' && suffix !== 'jpeg' && suffix !== 'png'"
        id="iframe"
        :src="`${previewUrl}#toolbar=0`"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        allowtransparency="yes"
      />
      <img v-show="suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png'" :src="previewUrl" />
    </div>

    <!-- <div class="preview-close ft-danger"><i class="el-icon-close" @click="close" /></div> -->
  </div>
</template>

<script>
import { download } from '../../../project/src/constant/utils'

export default {
  props: {
    width: { type: String, default: undefined },
    className: { type: String, default: '' },
  },
  data() {
    return {
      file: undefined,
      previewUrl: undefined,
      visible: false,
      boxWidth: this.width,
      loading: false,
      dragMinWidth: 250,
      dragMinHeight: 124,
      isMax: false,
      dragLeft: false,
      zindex: 1000,
      // 是否在职，在职true
      userInservice: true,
    }
  },
  computed: {
    suffix() {
      const previewUrl = this.previewUrl
      return (previewUrl && previewUrl.substr(previewUrl.lastIndexOf('.') + 1)) || ''
    },
  },
  watch: {
    width(val) {
      this.boxWidth = val
    },
  },
  methods: {
    downloadFile() {
      if (this.file) download(this.file)
    },
    max() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = '100vw'
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = true
    },
    revert() {
      this.$el.style.left = 0
      this.$el.style.top = '60px'
      this.$el.style.width = '40vw'
      this.$el.style.height = 'calc(100vh - 60px)'
      this.isMax = false
    },
    close() {
      this.visible = false
    },
    loadFileByUrl(url) {
      this.previewUrl = url
      this.show()
    },
    async getFile(file) {
      const { md5, fileId, _id } = file
      if (!md5 && !fileId && !_id) return
      this.loading = true
      this.file = file
      this.previewUrl = `https://alphahr.oss-cn-beijing.aliyuncs.com/documents/upload/${file.md5}.${file.originalname}`
      this.show()
      this.loading = false
    },
    show() {
      this.visible = true
      this.zindex = 1000
    },
    domdrag($el, event) {
      let startX, startY, clientX, clientY
      let isDrag = false
      event.preventDefault()
      // $el.style.zIndex = app.root.dragindex++
      startX = $el.offsetLeft
      startY = $el.offsetTop
      clientX = event.clientX
      clientY = event.clientY
      isDrag = true
      document.addEventListener('mousemove', e => {
        if (isDrag) {
          e.preventDefault()
          $el.style.left = `${e.clientX - clientX + startX}px`
          $el.style.top = `${e.clientY - clientY + startY}px`
        }
      })
      document.addEventListener('mouseup', e => {
        isDrag = false
      })
    },
    resize(oParent, handle, isLeft, isTop, lockX, lockY) {
      const { dragMinWidth, dragMinHeight, $el } = this
      const showCover = val => (this.dragLeft = val)
      handle.onmousedown = e => {
        showCover(true)
        const event = e || window.event
        const disX = event.clientX - handle.offsetLeft
        const disY = event.clientY - handle.offsetTop
        const iParentTop = oParent.offsetTop
        const iParentLeft = oParent.offsetLeft
        const iParentWidth = oParent.offsetWidth
        const iParentHeight = oParent.offsetHeight

        const iframe = $el.querySelector('#iframe')
        let iframeDocument = iframe.contentDocument

        if (iframeDocument) {
          iframeDocument.onmousemove = mouseMove
          iframeDocument.onmouseup = mouseUp
        } else {
          iframe.onload = function() {
            iframeDocument = iframe.contentDocument
            iframeDocument.onmousemove = mouseMove
            iframeDocument.onmouseup = mouseUp
          }
        }

        document.onmousemove = mouseMove
        document.onmouseup = mouseUp

        function mouseUp() {
          document.onmousemove = null
          document.onmouseup = null
          iframeDocument && (iframeDocument.onmousemove = null)
          iframeDocument && (iframeDocument.onmouseup = null)
          showCover(false)
        }
        function mouseMove(e) {
          const event = e || window.event
          const iL = event.clientX - disX
          const iT = event.clientY - disY
          const maxW = document.documentElement.clientWidth - oParent.offsetLeft - 2
          const maxH = document.documentElement.clientHeight - oParent.offsetTop - 2
          let iW = isLeft ? iParentWidth - iL : handle.offsetWidth + iL
          let iH = isTop ? iParentHeight - iT : handle.offsetHeight + iT
          const newTop = iParentTop + iT

          isLeft && iW >= dragMinWidth && (oParent.style.left = `${iParentLeft + iL}px`)
          iW < dragMinWidth && (iW = dragMinWidth)
          iW > maxW && (iW = maxW)
          lockX || (oParent.style.width = `${iW}px`)
          isTop && iH >= dragMinHeight && (oParent.style.top = `${newTop < 41 ? 41 : newTop}px`)
          iH < dragMinHeight && (iH = dragMinHeight)
          iH > maxH && (iH = maxH)
          lockY || (oParent.style.height = `${iH}px`)
          return false
        }

        return false
      }
    },
  },
}
</script>

<style src="../../statics/css/cvpreview.css"></style>
